var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('template',{slot:"header"},[_c('b-button',{staticClass:"breadcrumb-back-btn",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"fa fa-chevron-left fa-fw",attrs:{"aria-hidden":"true"}})]),_vm._v("\n    "+_vm._s(_vm.$t('APPLICANTS'))+"\n  ")],1),_c('basic-new-form')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }